import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { ModalInterface } from "app/interface/modal";
import { FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { ProfileService } from '@core/services/profile.service';

@Component({
    selector: 'app-unify-contacts',
    templateUrl: './unify-contacts.component.html',
    styleUrls: ['./unify-contacts.component.scss'],
    standalone: false
})
export class UnifyContactsComponent implements OnInit, AfterViewInit, ModalInterface {

    @ViewChild('UnifyContacts') modalTemplateRef: TemplateRef<any>;
    initiator: BehaviorSubject<boolean> = new BehaviorSubject(false);
    modalDialogRef: NxModalRef<any, any>;
    confirm: BehaviorSubject<SubmitEvent> = new BehaviorSubject(null);

    isSuccess: boolean = false;
    constructor(
        private dialogService: NxDialogService,
        private profileService: ProfileService,
    ) { 
    }

    openModal(): void {
        this.modalDialogRef = this.dialogService.open(this.modalTemplateRef, { 
            showCloseIcon: false,
            disableClose: true 
        });

        this.modalDialogRef.beforeClosed().subscribe(
            () => {
                if (this.isSuccess) {
                    window.location.reload();
                }
            }
        );
    }

    closeModal(): void {
        this.modalDialogRef.close();
    }

    ngAfterViewInit(): void {
        this.initiator.next(true);
    }

    ngOnInit(): void {
    }

    inputData(inputData?: any): void {
    }

    unifyContacts(){
        this.profileService.postUnifyContacts().subscribe(() => {
            this.isSuccess = true;
            this.closeModal();
        });
    }
}
